import { useState } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function HealthUnitModal({ open, onClose, onSuccess }) {
  const [nome, setNome] = useState('');
  const [endereco, setEndereco] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!nome) {
      toast.error('Preencha o nome da unidade');
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API}/health-units`, {
        nome,
        endereco
      });

      setNome('');
      setEndereco('');
      onSuccess();
      toast.success('Unidade cadastrada com sucesso!');
    } catch (error) {
      console.error('Erro ao criar unidade:', error);
      toast.error('Erro ao cadastrar unidade');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-xl">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold">Nova Unidade de Saúde</DialogTitle>
          <DialogDescription>
            Cadastre uma nova unidade de saúde no sistema
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="nome" className="text-sm font-medium mb-2 block">
              Nome da Unidade *
            </Label>
            <Input
              id="nome"
              data-testid="unit-name-input"
              value={nome}
              onChange={(e) => setNome(e.target.value.toUpperCase())}
              placeholder="UNIDADE DE SAÚDE DA FAMÍLIA..."
              className="bg-gray-50 border-transparent focus:border-primary/30 focus:bg-white transition-all rounded-lg h-12"
              required
            />
          </div>

          <div>
            <Label htmlFor="endereco" className="text-sm font-medium mb-2 block">
              Endereço
            </Label>
            <Input
              id="endereco"
              data-testid="unit-address-input"
              value={endereco}
              onChange={(e) => setEndereco(e.target.value)}
              placeholder="Rua, número, bairro..."
              className="bg-gray-50 border-transparent focus:border-primary/30 focus:bg-white transition-all rounded-lg h-12"
            />
          </div>

          <div className="flex gap-3 justify-end">
            <Button
              type="button"
              onClick={onClose}
              variant="outline"
              className="rounded-full px-6"
            >
              Cancelar
            </Button>
            <Button
              type="submit"
              data-testid="submit-unit-button"
              disabled={loading}
              className="bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg hover:shadow-xl transition-all duration-300 rounded-full px-6"
            >
              {loading ? 'Salvando...' : 'Salvar Unidade'}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
